// extracted by mini-css-extract-plugin
export var bodyRow = "_fd-d";
export var cardColumns = "_fd-e";
export var ellipsesOverflow = "_fd-2";
export var flatBottomCorners = "_fd-3";
export var flatTopCorners = "_fd-4";
export var headerActionsDropdown = "_fd-f";
export var headerBottomRow = "_fd-c";
export var headerTopRow = "_fd-b";
export var orderDetailsWrapper = "_fd-0";
export var orderInfoContainer = "_fd-1";
export var productDetails = "_fd-9";
export var productImage = "_fd-5";
export var responsiveTable = "_fd-8";
export var shipmentContainer = "_fd-a";
export var tableBottomLeft = "_fd-6";
export var tableBottomRight = "_fd-7";
export var trackingLink = "_fd-g";